<template>
  <div class="carousel-section-wrapper">
    <VueSlickCarousel v-bind="settings">
      <template>
        <!-- <div v-if="showBlock" class="item html-block">
          <v-container
            fluid
            :class="{ 'padding-lr': $vuetify.breakpoint.smAndDown }"
            class="py-0"
          >
            <v-row>
              <v-col cols="12" md="6" class="left-block">
                <img
                  :src="
                    require('@/assets/images/our-prices/image-left-block.png')
                  "
                  alt="Até 100 mil embalagens ao ano"
                />
                <h2>Até 100 mil embalagens ao ano</h2>
                <p>
                  Se você quer fazer a compensação de embalagens em apenas um
                  estado no Brasil, junto com a eu<b>reciclo</b>, e totalmente
                  online, sua empresa pode investir em uma compensação ambiental
                  de 22%, o mínimo exigido pela PNRS, até 200% para um impacto
                  positivo ainda maior no meio ambiente. Além desses benefícios,
                  sua empresa poderá estampar o selo eu<b>reciclo</b> nas
                  embalagens.
                </p>
                <a
                  target="_blank"
                  href="https://checkout-ms.eureciclo.io/checkout/prices"
                  class="v-btn"
                  >Compre online</a
                >
              </v-col>
              <v-col cols="12" md="6" class="right-block">
                <img
                  :src="
                    require('@/assets/images/our-prices/image-right-block.png')
                  "
                  alt="Mais de 100 mil embalagens ao ano"
                />
                <h2>Mais de 100 mil embalagens ao ano</h2>
                <p>
                  Para fazer a compensação de embalagens em apenas vários
                  estados no Brasil e também para este volume maior de
                  embalagens, nosso contato será mais personalizado. Em uma
                  conversa com um especialista eu<b>reciclo</b>, vamos entender
                  a necessidade e a estratégia sustentável da sua empresa, para
                  definir qual percentual de compensação ambiental se encaixa
                  mais com o que procuram. De 22%, até 200%, para o dobro de
                  impacto!
                </p>
                <a
                  target="_blank"
                  href="https://info.eureciclo.com.br/solucao-eureciclo-mato-grosso-sul"
                  class="v-btn"
                  >Solicitar contato</a
                >
              </v-col>
            </v-row>
          </v-container>
        </div> -->
        <div v-for="(item, i) in options.CarouselItems" :key="i" class="item">
          <a
            :href="item.url ? item.url : 'javascript:void(0)'"
            :target="item.url ? '_blank' : '_self'"
            :title="item.title"
            class="image-wrapper"
            :style="!item.url ? 'cursor: default' : ''"
          >
            <picture v-if="$vuetify.breakpoint.smAndDown">
              <source
                :srcset="
                  require('@/assets/images/homepage/' +
                    item.imageMobile +
                    '.webp')
                "
                type="image/webp"
              />
              <source
                :srcset="
                  require('@/assets/images/homepage/' +
                    item.imageMobile +
                    '.png')
                "
                type="image/png"
              />
              <img
                :src="
                  require('@/assets/images/homepage/' +
                    item.imageMobile +
                    '.png')
                "
                :alt="item.title"
              />
            </picture>
            <picture v-else>
              <source
                :srcset="
                  require('@/assets/images/homepage/' + item.image + '.webp')
                "
                type="image/webp"
              />
              <source
                :srcset="
                  require('@/assets/images/homepage/' + item.image + '.png')
                "
                type="image/png"
              />
              <img
                :src="
                  require('@/assets/images/homepage/' + item.image + '.png')
                "
                :alt="item.title"
              />
            </picture>
          </a>
        </div>
      </template>
    </VueSlickCarousel>
  </div>
</template>
<script>
import VueSlickCarousel from 'vue-slick-carousel';
import 'vue-slick-carousel/dist/vue-slick-carousel.css';
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css';
import { parseISO, isAfter, isBefore } from 'date-fns';

export default {
  name: 'HeroCarouselComponent',
  components: {
    VueSlickCarousel,
  },
  props: {
    options: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      settings: {
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        swipeToSlide: true,
        arrows: true,
        dots: false,
        autoplay: false,
        autoplaySpeed: 8000,
        adaptiveHeight: true,
      },
      showBlock: false,
    };
  },
  mounted() {
    const dateStart = '2023-10-03 23:59:00';
    const dateFinish = '2023-12-08 23:59:00';
    const parsedDateStart = parseISO(dateStart);
    const parsedDateFinish = parseISO(dateFinish);

    const past = isAfter(new Date(), parsedDateStart);
    const future = isBefore(new Date(), parsedDateFinish);

    if (past && future) {
      this.showBlock = true;
    }
  },
};
</script>

<style lang="sass" scoped>
@import '@/styles/util'
@import '@/styles/style'

.carousel-section-wrapper
  background-color: rgb(38, 208, 124)
  max-height: 795px
  @media screen and (max-width: 959px)
    max-height: 100%
  ::v-deep
    .slick-prev,
    .slick-next
      z-index: 3
      width: 50px
      height: 50px
      &:before
        color: #26d07c
        font-size: 50px
    .slick-prev
      left: 20px
    .slick-next
      right: 20px
  .item
    .image-wrapper
      display: block
      width: 100%
      height: 100%
      outline: none
      img
        display: block
        width: 100%
  .html-block
    .left-block,
    .right-block
      position: relative
      padding: 4%
      @media screen and (min-width: 1180px)
        display: flex
        flex-flow: column
        align-items: flex-start
        justify-content: center
        min-height: 750px
      h2
        font-family: 'metropolismedium', serif
        font-weight: 700
        font-size: 40px
        color: #003036
        line-height: 1.4
        margin-bottom: 30px
        @media screen and (max-width: 959px)
          font-size: 24px
          max-width: 180px
      p
        position: relative
        font-family: 'metropolisregular'
        font-weight: 400
        font-size: 20px
        color: #003036
        line-height: 1.4
        margin-bottom: 50px
        z-index: 1
      img
        content: ''
        position: absolute
        display: block
        bottom: 0
        right: 0
        width: 336px
        height: 224px
        padding: 0
        margin: 0
        border-radius: 200px 0px 0px 0px
        z-index: 0
        @media screen and (max-width: 1179px)
          width: 32% !important
        @media screen and (max-width: 959px)
          bottom: inherit
          top: 0
          height: auto
          border-radius: 0px 0px 0px 100px
        @media screen and (max-width: 500px)
          width: 45% !important
          height: auto
        @media screen and (max-width: 425px)
          height: 100px
        @media screen and (min-width: 1180px) and (max-width: 1199px)
          width: 50% !important
          height: auto
      .v-btn
        position: relative
        font-family: "metropolisbold" !important
        font-weight: 700 !important
        font-size: 18px !important
        color: #003036 !important
        line-height: 1
        letter-spacing: 1px
        text-transform: inherit
        padding: 22px 44px
        border-radius: 6px
        z-index: 1
        -webkit-box-shadow: none
        box-shadow: none
    .left-block
      background-color: #EEFBF5
      border-top: 4px solid #26D07C
      @media screen and (max-width: 959px)
        border-top: 2px solid #26D07C
      .v-btn
        background: #26D07C !important
    .right-block
      background-color: #FFF6D9
      border-top: 4px solid #F4633A
      @media screen and (max-width: 959px)
        border-top: 2px solid #F4633A
      .v-btn
        background: transparent !important
        border: 1px solid #F4633A
  @media screen and (max-width: 959px)
</style>
